import useTranslation from 'next-translate/useTranslation'

import Breadcrumbs from '@/atoms/Breadcrumb'
import useCreators from '@/hooks/useCreators'
import FilterGroup from '@/ts/interfaces/global/FilterGroup'
import Presentation from '@/views/common/Presentation'

import CreatorsGrid from './includes/CreatorsGrid'

function CreatorsView({ filters }: { filters: FilterGroup }) {
  const { t } = useTranslation('global')

  const data = useCreators()
  const { creators, count, isLoading } = data

  const noResults = !isLoading && count <= 0
  const shouldDisplayContent = count > 0 && creators.length > 0

  return (
    <div>
      <Breadcrumbs crumbs={[{ label: t('creators') }]} className="mb-8" />
      <div className="space-y-10 md:space-y-20 ">
        <Presentation
          withoutSort
          totalItems={count}
          noResults={noResults}
          filters={filters}
          title="all_creators"
          shouldDisplayContent={shouldDisplayContent}
        >
          <CreatorsGrid creators={creators} />
        </Presentation>
      </div>
    </div>
  )
}

export default CreatorsView
